module.exports = __webpack_public_path__ + "img/sharing-links.610061ff.svg";